import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import healthStatusMixin from '@/components/core/virtualDevice/healthStatusMixin';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import get from 'lodash/get';
import moment from 'moment';
export default {
  name: 'ViewVirtualDevicesMap',
  mixins: [MapViewMixin, listOptionsPersistenceMixin, multiSearchMixin, healthStatusMixin],
  data: function data() {
    return {
      disableFetchOnCreatedMixin: true,
      lastSearch: null,
      // share the list-persistence with the virtual-device-list
      listPersistencePath: 'VirtualDevice.list',
      searchMode: 'multi',
      searchOperator: 'AND',
      historyFrom: null,
      initialAccounts: [],
      listIsReadyToFetch: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    requestFilter: function requestFilter() {
      if (this.selectedAccounts.length === 0) {
        return [];
      }

      return [{
        type: 'tenantIds',
        ids: this.selectedAccounts
      }];
    }
  }),
  watch: {
    selectedAccounts: function selectedAccounts() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
      this.fetchGeoMetaInfos();
    },
    // language-check to update search-types in searchTypesMixin
    listIsReadyToFetch: function listIsReadyToFetch(newV, oldV) {
      if (newV && !oldV) {
        this.loadInitialData();
      }
    }
  },
  mounted: function mounted() {
    this.historyFrom = moment(new Date()).subtract(2, 'months').unix(); // multi-data fetch in searchTypesMixin

    this.getMultiFilterData();
    var _this$$route$query = this.$route.query,
        view = _this$$route$query.view,
        mode = _this$$route$query.mode;

    if (!view) {
      this.listIsReadyToFetch = true;
    } else {
      this.listIsReadyToFetch = false;
      this.setUpMonitoringViewList(view, mode);
    }
  },
  methods: {
    setUpMonitoringViewList: function setUpMonitoringViewList(viewId, mode) {
      var _this = this;

      this.$router.replace({
        query: null
      });
      ApiService.virtualDeviceViewGet(this, viewId).then(function (data) {
        var search = data.viewConfig.searchItems;
        _this.searchOperator = data.viewConfig.searchOperator;
        _this.searchItems = search.map(function (item) {
          return {
            param: item.variable,
            search: item.search
          };
        }); // persist search items and operator in store

        _this.$store.dispatch('app/updateVirtualDeviceListSearch', {
          items: _this.searchItems,
          operator: _this.searchOperator
        });

        if (mode === 'warnings') {
          _this.searchItems.push({
            param: 'health',
            search: {
              value: '1',
              text: 'Warning'
            }
          });
        }

        if (mode === 'errors') {
          _this.searchItems.push({
            param: 'health',
            search: {
              value: '2',
              text: 'Alert'
            }
          });
        }

        var accounts = [data.tenantId];
        _this.initialAccounts = accounts;

        _this.$nextTick(function () {
          _this.listIsReadyToFetch = true;
        });
      }).catch(function () {
        _this.listIsReadyToFetch = true;

        _this.$snack(_this.$i18n_t('DigitalTwin.VirtualDevice.snacks.loadMonitoringViewFailed'), 'error');
      });
    },
    handleHistoryFromPicked: function handleHistoryFromPicked(dateObject) {
      this.historyFrom = dateObject.from;
    },
    breadCrumbsPath: function breadCrumbsPath() {
      return [{
        to: '/virtual-devices',
        text: this.$i18n_t('Common.drawer.virtualDevices')
      }, this.$i18n_t('DigitalTwin.VirtualDevice.map.title')];
    },
    searchUpdated: function searchUpdated(search, searchOperator) {
      this.searchItems = search;
      this.searchOperator = searchOperator;
      this.fetchList();
    },
    // from listPersistenceMixin, forward to cluster-request
    fetchList: function fetchList() {
      if (this.$refs && this.$refs.mapInstance) {
        this.$refs.mapInstance.debouncedRequestClusterRequest();
      }

      return this.fetchGeoMetaInfos();
    },
    fetchGeoMetaInfos: function fetchGeoMetaInfos() {
      var _this2 = this;

      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var filters = [{
        type: 'tenantIds',
        ids: this.selectedAccounts
      }];
      return ApiService.virtualDeviceFetchGeoMetaInfos(this, filters, searchItems, this.searchOperator).then(function (data) {
        _this2.stateKeys = data.keyList;
        _this2.floorList = data.floorList;
      }).catch(function (error) {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    fetchTwinData: function fetchTwinData() {
      this.loadTree();
      return this.fetchGeoMetaInfos();
    },
    resetDefaults: function resetDefaults() {
      this.selectedStateKey = null;
      this.gradientPolygonColours = false;
    },
    valuesToPersist: function valuesToPersist() {
      return {
        gradientPolygonColours: this.gradientPolygonColours,
        excludeZones: this.excludeZones,
        selectedStateKey: this.selectedStateKey
      };
    },
    getClusterContent: function getClusterContent(cluster, bounds) {
      var _this3 = this;

      if (!cluster) {
        this.selectedCluster = {};
        return;
      }

      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var filters = [{
        type: 'tenantIds',
        ids: this.selectedAccounts
      }];
      ApiService.virtualDeviceGetGeoClusterContent(this, cluster.id, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], filters, searchItems).then(function (data) {
        _this3.selectedCluster = _objectSpread(_objectSpread({}, cluster), {}, {
          items: data.vdevices
        });
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree: function loadTree() {
      var _this4 = this;

      var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var filters = [{
        type: 'tenantIds',
        ids: this.selectedAccounts
      }]; // persist options for next call of this page (during this browser-tab-session)

      this.$store.state.app.pageFilters = _objectSpread(_objectSpread({}, this.$store.state.app.pageFilters), {}, {
        VirtualDevice: _objectSpread(_objectSpread({}, get(this.$store.state.app, 'pageFilters.VirtualDevice') || {}), {}, {
          list: _objectSpread(_objectSpread({}, get(this.$store.state.app, 'pageFilters.VirtualDevice.list') || {}), {}, {
            searchDetails: this.searchItems,
            searchOperator: this.searchOperator
          })
        })
      });
      return ApiService.virtualDeviceFetchGeoClusters(this, this.indoorFloorDtwinId, bounds, this.selectedStateKey, filters, searchItems, {
        hideStatelessPolygons: this.hideStatelessPolygons
      }, this.searchOperator).then(function (data) {
        _this4.calculateBoundingBox(data);

        _this4.markerItems = data.vdevices;
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      }).finally(function () {
        _this4.$store.state.app.loading = false;
      });
    }
  }
};